import type { MenuItem } from '~/types/adminApi';
import { EMenuType } from '~/types/enums';

export const navItems: MenuItem[] = [
    {
        groupIds: [],
        hasArchive: false,
        hiddenHeader: false,
        id: 572,
        link: 'accountHP',
        orderBy: null,
        pageSlug: '',
        position: 0,
        postGroupIds: [],
        title: 'Nástěnka',
        type: EMenuType.DASHBOARD,
        calendarDisplayMode: null,
        customMenuIcon: {
            title: 'customPage',
            iconSvg: `
                <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                    <polygon points="14,0 28,14 14,28 0,14" fill="green" />
                </svg>
            `
        },
        items: [],
    },
    {
        id: 583,
        title: 'Custom Page',
        type: EMenuType.CUSTOM_PAGE,
        orderBy: null,
        position: 1,
        link: 'button',
        pageSlug: '',
        groupIds: [],
        postGroupIds: [],
        hiddenHeader: false,
        hasArchive: false,
        calendarDisplayMode: null,
        customMenuIcon: {
            title: 'customPage',
            iconSvg: `
                <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                    <rect width="28" height="28" fill="black" />
                </svg>
            `
        },
        items: []
    },
    {
        id: 609,
        title: 'Kalendář akcí',
        type: EMenuType.EVENT_CALENDAR,
        orderBy: null,
        position: 2,
        link: 'event-calendar',
        pageSlug: '',
        groupIds: [],
        postGroupIds: [],
        hiddenHeader: false,
        hasArchive: false,
        calendarDisplayMode: 'calendar',
        customMenuIcon:
            {
                title: 'event_calendar',
                iconSvg: `
                    <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="14,0 28,28 0,28" fill="red" />
                    </svg>
                `
            },
        items: []
    },
    {
        id: 702,
        title: 'RSS Zlin',
        type: EMenuType.RSS,
        orderBy: null,
        position: 3,
        link: 'https://zlin.munipolis.cz/rss',
        pageSlug: 'rss-zlin',
        groupIds: [],
        postGroupIds: [],
        hiddenHeader: false,
        hasArchive: false,
        calendarDisplayMode: null,
        customMenuIcon:
            {
                title: 'rss-page',
                iconSvg: `
                    <svg width="20" height="28" xmlns="http://www.w3.org/2000/svg">
                        <rect width="20" height="28" fill="yellow" />
                    </svg>
                `
            },
        items: []
    },
    {
        id: 79979,
        title: 'Prispevky',
        type: EMenuType.POSTS_PAGE,
        orderBy: null,
        position: 4,
        link: '',
        pageSlug: 'prispevky',
        groupIds: [],
        postGroupIds: [ 8457 ],
        hiddenHeader: false,
        hasArchive: false,
        calendarDisplayMode: null,
        customMenuIcon:
            {
                title: 'posts',
                iconSvg: `
                    <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="14" cy="14" r="14" fill="darkblue" />
                    </svg>
                `
            },
        items: []
    },
    {
        id: 615,
        title: 'Praktické informace',
        type: EMenuType.MENU_COLLECTION,
        orderBy: null,
        position: 5,
        link: '',
        pageSlug: 'prakticke-informace',
        groupIds: [],
        postGroupIds: [],
        hiddenHeader: false,
        hasArchive: false,
        calendarDisplayMode: null,
        customMenuIcon:
            {
                title: 'trees',
                iconSvg: `
                    <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="14,2 26,10 21,26 7,26 2,10" fill="#4B0082"/>
                    </svg>
                `
            },
        items:
            [
                {
                    id: 617,
                    title: '0dpadové hospodářství',
                    type: EMenuType.MENU_COLLECTION,
                    orderBy: null,
                    position: 0,
                    link: '',
                    pageSlug: '0dpadove-hospodarstvi',
                    groupIds: [],
                    postGroupIds: [],
                    hiddenHeader: false,
                    hasArchive: false,
                    calendarDisplayMode: null,
                    customMenuIcon: {
                        title: 'trees',
                        iconSvg: `
                            <svg width="20" height="28" xmlns="http://www.w3.org/2000/svg">
                                <rect width="20" height="28" fill="yellow" />
                            </svg>
                        `
                    },
                    items: []
                }
            ]
    }
];
